import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
try {
  require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css not found, proceeding without it.');
}
import { jsxs, jsx } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { ExtendableImage } from '@design-system/extendable-image';
import { HeadingBlock } from '@design-system/heading-block';
import classNames from 'classnames';
import { forwardRef } from 'react';
var AssetItem = forwardRef(function (_ref, ref) {
  var className = _ref.className,
    headingBlock = _ref.headingBlock,
    image = _ref.image,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'start' : _ref$align,
    ctaBlock = _ref.ctaBlock,
    _ref$mediaVariant = _ref.mediaVariant,
    mediaVariant = _ref$mediaVariant === void 0 ? 'rounded' : _ref$mediaVariant,
    _ref$tag = _ref.tag,
    Tag = _ref$tag === void 0 ? 'div' : _ref$tag;
  var headingBlockProps = Object.assign(Object.assign({}, headingBlock), {
    align: align
  });
  return jsxs(Tag, Object.assign({
    ref: ref,
    className: classNames('cds-asset-item', className, _defineProperty({}, "cds-asset-item--align-".concat(align), align))
  }, {
    children: [jsx("div", Object.assign({
      className: "cds-asset-item__content"
    }, {
      children: jsxs("div", Object.assign({
        className: "cds-asset-item__content-inner"
      }, {
        children: [jsx(HeadingBlock, Object.assign({}, headingBlockProps)), ctaBlock && jsx(CtaBlock, Object.assign({
          align: align
        }, ctaBlock))]
      }))
    })), image && jsx("div", Object.assign({
      className: classNames('cds-asset-item__media', "cds-asset-item__media--".concat(mediaVariant))
    }, {
      children: jsx(ExtendableImage, Object.assign({}, image, {
        className: "cds-asset-item__media-image"
      }))
    }))]
  }));
});
export { AssetItem };